import { Key } from './types';

export const NBSP = '\u00A0';
export const DASH = '\u2014';
export const noOp: () => any = () => {}; // eslint-disable-line
export const MAX_PAX_AMOUNT = 9;
export const getKey = (e: KeyboardEvent): Key | undefined => {
  // code is the new standard but not yet supported by all browsers
  // keyCode is deprecated but used as a fallback
  if (e.code) {
    return e.code as Key;
  }
  switch (e.keyCode) {
    case 9:
      return Key.TAB;
    case 13:
      return Key.ENTER;
    case 27:
      return Key.ESC;
    case 32:
      return Key.SPACE;
    case 37:
      return Key.ARROW_LEFT;
    case 38:
      return Key.ARROW_UP;
    case 39:
      return Key.ARROW_RIGHT;
    case 40:
      return Key.ARROW_DOWN;

    default:
      return undefined;
  }
};
export const BREAKPOINT_LARGE = 1024;
export const HORIZONTAL_WIDTH = 811; // $horizontal-width - 1
export const MEDIA_QUERY_LAPTOP_UP = `(min-width: ${BREAKPOINT_LARGE}px)`;
export const ANIMATION_DURATION = 350; // $animation-duration .35s

// Copied from ux redir-generator.ts
export const ALLOWED_LOCALES: string[] = [
  'en_001',
  'de_AT',
  'en_AT',
  'en_AU',
  'en_BE',
  'en_CA',
  'fr_CA',
  'de_CH',
  'en_CH',
  'fr_CH',
  'en_CN',
  'zh_CN',
  'en_CZ',
  'de_DE',
  'en_DE',
  'da_DK',
  'en_DK',
  'en_EE',
  'en',
  'en_ES',
  'es_ES',
  'en_FI',
  'fi_FI',
  'sv_FI',
  'en_FR',
  'fr_FR',
  'en_GB',
  'zh_HK',
  'en_HK',
  'en_HU',
  'en_IS',
  'en_IE',
  'en_IL',
  'en_IN',
  'en_IT',
  'it_IT',
  'en_JP',
  'ja_JP',
  'en_KR',
  'ko_KR',
  'en_LT',
  'en_LV',
  'en_NL',
  'en_NO',
  'no_NO',
  'en_PL',
  'pl_PL',
  'en_PT',
  'en_RU',
  'ru_RU',
  'en_SE',
  'sv_SE',
  'en_SG',
  'en_TH',
  'en_US',
];

// todo #am
export const MAX_AM_PAX_AMOUNT = {
  adults: {
    maxPerRoom: 9,
    minPerRoom: 1,
    maxTotal: 9,
  },
  children: {
    maxPerRoom: 5,
    minPerRoom: 0,
    maxTotal: 6,
  },
  maxTotalPax: 9,
  maxTotalRooms: 3,
};

export const SUPPORTED_AM_LOCALES = ['fi_FI', 'sv_FI', 'en_FI'];
export const PREVIOUS_SEARCHES_KEY = 'finnaircom.previousSearches';
export const REGEX_PROMO_CODE = /^[A-Z0-9\-_]{2,15}$/;
export const DEFAULT_COUNTRY_CODE = 'INT';
export const DEFAULT_LANGUAGE = 'GB';
export const DEFAULT_LOCALE = 'en';
